var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('base-business-contact',{attrs:{"title":"Get in Touch","pace":"6"}},[_vm._v("\n    Please feel free to reach out to us with your questions and comments.\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }